<template>
  <header :style="{height: `${height}px`}">
    <div class="header__placeholder" />

    <div ref="header" class="header u-z-back u-row u-pad-x-1of12 u-pad-y-sm--sm u-middle" :class="{'is-transparent': isTransparent}">
      <router-link :to="$local('Homepage')" class="u-w1of10">
        <img
          :src="isTransparent ? '/images/bright__logo--white.png' : '/images/bright__logo.png'"
          alt="Bright logo"
          class="header__logo"
          :class="{'is-visible': $route.name !== 'Homepage'}"
        />
      </router-link>
      <nav class="u-w9of10">
        <div class="u-row u-right u-middle u-blue">
          <template v-if="!$device.isTouch">
            <router-link v-if="contact && contact.length" :to="{...$local('Contact'), params: {slug: contact[0].slug }}" class="header__round t-text--small t-bold u-marg-l-md" :class="{'is-opaque': isTransparent}">
              Contact
            </router-link>

            <component :is="item.href ? 'app-header-link' : 'div'" :to="item.href" ref="item" class="menu u-relative u-pad-md t-bold t-text--small u-cursor-pointer u-black u-block" v-for="item in items" :key="item.titre">
              <app-header-link v-if="item.href" :to="item.href">
                {{ item.titre }}
              </app-header-link>
              <span v-else>
                {{ item.titre }}
              </span>
              <div
                class="menu__wrapper u-bg-white u-radius js-item"
                 v-if="item.links"
                :style="{
                  width: `calc(${item.links.length*130}px + 30px)`
                }"
              >
                <div class="u-row u-center">
                  <app-header-link :to="link.href" v-for="(link, index) in item.links" :key="index" class="menu__wrapper__item u-pad-x-sm u-pad-y-md">
                    <div v-if="item.previews[index]" class="u-pad-x-sm">
                      <div class="u-box-1by1">
                        <app-image :id="item.previews[index].id" :src="item.previews[index].url" class="u-wrapper-panel u-round u-overflow-hidden" />
                      </div>
                    </div>
                    <div class="t-text--xsmall u-marg-t-sm u-center">
                      {{ link.title }}
                    </div>
                  </app-header-link>
                </div>
              </div>
            </component>
          </template>
          <template v-else>
            <div class="menu__btn--open" @click="isMenuOpen = !isMenuOpen">
              <div class="menu__btn--open__top" />
              <div class="menu__btn--open__bottom" />
              <div class="menu__btn--open__middle" />
            </div>
          </template>
        </div>
      </nav>
    </div>
    <transition name="t-fader">
      <div class="menu-mobile u-bg-blue u-z-front u-overflow-scroll" v-if="isMenuOpen" >
        <div class="u-row u-pad-x-1of12 u-pad-y-md u-middle" :class="{'is-transparent': isTransparent}">
          <router-link :to="$local('Homepage')" class="u-w2of10">
            <img src="/images/bright__logo--white.png" alt="Bright logo" class="u-block u-full-width"/>
          </router-link>
          <div class="u-w8of10 u-right u-flex">
            <div class="menu__btn--close" @click="isMenuOpen = !isMenuOpen">
              <div class="menu__btn--close__top" />
              <div class="menu__btn--close__bottom" />
            </div>
          </div>
        </div>


        <div v-if="contact && contact.length" class="u-pad-x-1of12 u-marg-y-md">
          <div class="u-bg-white u-radius u-row u-center u-pad-sm">
            <div class="u-full-width u-center t-h2 u-blue u-marg-t-md u-marg-b-md">
              <router-link :to="{...$local('Contact'), params: {slug: contact[0].slug }}">
                Contact
              </router-link>
            </div>
          </div>
        </div>

        <div class="u-pad-x-1of12 u-marg-y-md" v-for="item in items">
          <div class="u-bg-white u-radius u-row u-center u-pad-sm">
            <div class="u-full-width u-center t-h2 u-blue u-marg-t-md u-marg-b-md">
              <app-header-link v-if="item.href" :to="item.href">
                {{ item.titre }}
              </app-header-link>
              <span v-else>
                {{ item.titre }}
              </span>
            </div>
            <app-header-link v-if="item.links.length" :to="link.href" v-for="(link, index) in item.links" :key="index" class="u-pad-x-sm u-pad-b-md u-pad-t-sm u-w6of12">
              <div v-if="item.previews[index]" class="u-pad-x-sm">
                <div class="u-box-1by1">
                  <app-image :id="item.previews[index].id" :src="item.previews[index].url" class="u-wrapper-panel u-fit-cover u-round" />
                </div>
              </div>
              <div class="t-text u-marg-t-sm u-center u-bold">
                {{ link.title }}
              </div>
            </app-header-link>
          </div>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import AppHeaderLink from '@/components/AppHeaderLink'

export default {
  components: {
    AppHeaderLink
  },

  props: {
    isTransparent: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      height: 0,
      isMenuOpen: false
    }
  },

  computed: {
    items () {
      return this.$store.getters['data/menu']
    },
    contact () {
      return this.$store.getters['data/contact']
    }
  },

  mounted () {
    this.onResize()
  },

  methods: {
    onResize () {
      this.height = this.$refs.header.offsetHeight

      if (this.$refs.item) {
        this.$refs.item.forEach(item => {
          const el = item.querySelector('.js-item')

          if (!el) { return }
          const pos = this.$offset.absolute(item)
          const wrapperWidth = item.offsetWidth
          const width = el.offsetWidth


          if (pos.left + (wrapperWidth + width) * .5 < this.$device.width) {
            el.style.left = -width * .5 + 'px'
          } else {
            el.style.left = -(pos.left + width - this.$device.width) - 30 + 'px'
          }
        })
      }
    }
  },

  watch: {
    items () {
      requestAnimationFrame(this.onResize)
    },
    isMenuOpen () {
      this.$emit('onMenuOpen', this.isMenuOpen)
    },
    $route () {
      this.isMenuOpen = false
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.header
  background-color: $colors.white
  position fixed
  top 0
  left 0
  width 100%

  &.is-transparent
    position absolute
    background-color: transparent
  
  &__round
    position relative
    padding 1em 1.7em 1.05em
    z-index 0
    color: $colors.blue

    &:before
      z-index -1
      content ''
      position absolute
      top 15%
      left 10%
      height 70%
      width 80%
      border-radius 30px
      opacity .3
      transform scale(1, 1)
      transition transform .3s ease-in-out-quad
      background: $colors.blue
  
    &:hover:before
      transform scale(1.1, 1.1)

  .is-opaque
    color: $colors.white
    
    &:before
      opacity 1

  &__logo
    height 50px
    opacity 0
    transition opacity .5s linear

    &.is-visible
      opacity 1
      color: $colors.white
  
.menu
  color: black !important
  &__wrapper
    position absolute
    top 100%
    width 500px
    left calc( 50% - 250px )
    pointer-events none
    transform translateY(20px) translateZ(0)
    opacity 0
    transition transform .3s ease-in-out-quad, opacity .3s linear
  
    &__item
      width 130px
  
  &:after
    content ''
    position absolute
    top 100%
    left 50%
    transform translate3d(-50%, calc( -50% + 20px ), 0)
    height 30px
    width 30px
    border-radius 50%
    background-color $colors.white
    transition transform .3s ease-in-out-quad, opacity .3s linear
    opacity 0
    
  &:hover:after
    opacity 1
    transform translate3d(-50%, -50%, 0)

  &:hover &__wrapper
    transform translateY(0) translateZ(0)
    opacity 1
    pointer-events all
  
  &__btn--open
    height 1.3em
    width 2em
    position relative
    
    &__top
      position absolute
      top 0
      left 0
      height 2px
      width 100%
      background-color $colors.black

    &__middle
      position absolute
      top calc( 50% - 1px )
      left 0
      height 2px
      width 100%
      background-color $colors.black

    &__bottom
      position absolute
      bottom 0
      left 0
      height 2px
      width 100%
      background-color $colors.black
  
  &__btn--close
    height 1.3em
    width 2em
    position relative
    
    &__top, &__bottom
      position absolute
      top 0
      left 0
      height 2px
      width 100%
      transform translateX(-10px) rotate(-45deg)
      transform-origin 100% 0%
      background-color $colors.white
    &__bottom
      transform rotate(45deg)
      transform-origin 0% 0%
  
.menu-mobile 
  position absolute
  left 0
  height 100%
  top 0
  width 100%
</style>